import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '../../helpers';
import { body } from '../typography';

const baseBadgeClassName = cn(
  'inline-flex gap-1 items-center justify-center rounded-lg w-fit transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2',
  body({ size: 'sm' }),
);

const badgeVariants = cva(baseBadgeClassName, {
  variants: {
    variant: {
      primaryNeutral: 'bg-white border border-neutral-20 text-black',
      primaryAccent: 'bg-blurple-500 text-white',
      primaryWarning: 'bg-orange-600 text-white',
      primaryNegative: 'bg-red-600 text-white',
      primaryPositive: 'bg-green-600 text-white',
      secondaryNeutral: 'bg-neutral-50 text-black',
      secondaryAccent: 'bg-blurple-100 text-blurple-500',
      secondaryWarning: 'bg-orange-100 text-orange-700',
      secondaryNegative: 'bg-red-100 text-red-700',
      secondaryPositive: 'bg-green-100 text-green-700',
      tertiaryNeutral: 'text-black',
      tertiaryAccent: 'text-blurple-500',
      tertiaryWarning: 'text-orange-700',
      tertiaryNegative: 'text-red-700',
      tertiaryPositive: 'text-green-700',
    },
    size: {
      lg: 'px-3 py-2 text-sm',
      md: 'px-2 py-2 text-xs',
    },
    notification: {
      lg: 'px-3 py-2 text-sm rounded-full w-8 h-8',
      md: 'px-3 py-2 text-xs rounded-full w-6 h-6',
      sm: 'p-0 text-xs rounded-full w-5 h-5',
      xs: 'p-0 rounded-full w-3 h-3',
      xxs: 'p-0 rounded-full w-2 h-2',
    },
    disabled: {
      true: '',
      false: '',
    },
  },
  compoundVariants: [
    {
      disabled: true,
      variant: ['secondaryNeutral', 'tertiaryNeutral'],
      className: 'text-neutral-400',
    },
    {
      disabled: true,
      variant: ['secondaryAccent', 'tertiaryAccent'],
      className: 'text-blurple-300',
    },
    {
      disabled: true,
      variant: ['secondaryWarning', 'tertiaryWarning'],
      className: 'text-orange-300',
    },
    {
      disabled: true,
      variant: ['secondaryNegative', 'tertiaryNegative'],
      className: 'text-red-300',
    },
    {
      disabled: true,
      variant: ['secondaryPositive', 'tertiaryPositive'],
      className: 'text-green-300',
    },
  ],
  defaultVariants: {
    variant: 'primaryNeutral',
    size: 'md',
    disabled: false,
  },
});

type BadgeVariants = VariantProps<typeof badgeVariants>;
export type BadgeVariant = NonNullable<BadgeVariants['variant']>;
export type BadgeSize = NonNullable<BadgeVariants['size']>;
export type BadgeNotification = NonNullable<BadgeVariants['notification']>;

export { badgeVariants, baseBadgeClassName };
